var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 13.2 11.2",
    style: {
      enableBackground: "new 0 0 13.2 11.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st2{clip-path:url(#SVGID_00000080202069597896766380000016949497559632471453_);}\r\n\t.st3{clip-path:url(#SVGID_00000031192324712593753270000018112468370778853028_);}\r\n\t.st4{fill:#F2F2F2;}\r\n\t.st5{fill:#BDB6B8;}\r\n\t.st6{fill:#1A1A1A;}\r\n\t.st7{fill:#ADA8AA;}\r\n\t.st8{fill:#262424;}\r\n\t.st9{fill:#1E8273;}\r\n\t.st10{fill:#239281;}\r\n\t.st11{fill:#262626;}\r\n\t.st12{fill:#0F0F0F;}\r\n\t.st13{fill:#212226;}\r\n\t.st14{opacity:0.25;}\r\n\t.st15{clip-path:url(#SVGID_00000178899837084700516630000010679597860030420873_);}\r\n\t.st16{opacity:0.15;}\r\n\t.st17{clip-path:url(#SVGID_00000145764190698614017070000011029848775184857000_);}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path_7407_00000097500724318214667580000009806049108456341900_",
    className: "st0",
    d: "M0.3,10.9L0.3,10.9c-0.4-0.4-0.4-1,0-1.4 l3.9-3.9L0.3,1.7c-0.4-0.4-0.4-1,0-1.4l0,0c0.4-0.4,1-0.4,1.4,0l4.6,4.6c0.4,0.4,0.4,1,0,1.4l-4.6,4.6C1.3,11.3,0.7,11.3,0.3,10.9z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7408_00000017505094784830537650000013224530543697490616_",
    className: "st0",
    d: "M6.9,10.9L6.9,10.9c-0.4-0.4-0.4-1,0-1.4 l3.9-3.9L6.9,1.7c-0.4-0.4-0.4-1,0-1.4l0,0c0.4-0.4,1-0.4,1.4,0l4.6,4.6c0.4,0.4,0.4,1,0,1.4l-4.6,4.6C7.9,11.3,7.3,11.3,6.9,10.9z "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSidebar);
export default __webpack_public_path__ + "static/media/icon_sidebar.25fa9e9082cc23b519c1716ad310b440.svg";
export { ForwardRef as ReactComponent };